(function(){
  function boot(root){
    var els = (root||document).querySelectorAll('.nyxp-reveal:not(.is-in)');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.06});
    els.forEach(function(e){ io.observe(e); });
  }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function(){ boot(); });
  document.addEventListener('shopify:section:load', function(e){ (e.target.querySelectorAll('.nyxp-reveal')||[]).forEach(function(n){n.classList.add('is-in')}); });
})();